export const getResponseErrorMessage = (response: Response) => {
  const statusCode = response?.status
    ? `${response.status} ${response.statusText}`
    : "unknown";

  return `There was an error with the call to /api/productdetails/getproductpurchasingactivity. Status code: ${statusCode}`;
};

export const shouldLogError = (response: Response) => {
  // Don't log 500 errors since should be logged on the server
  // Also, don't log 429 (Too Many Requests) or 403 (Forbidden) errors at this time
  // as the logs are currently noisy and issue doesn't appear to be due to
  // a problem with this component's implementation.
  return (
    response.status < 500 && response.status !== 429 && response.status !== 403
  );
};
